import type { ItemNames } from '@ps-smart-cp/ppfw-client';
import {
  Characters,
  type ItemAttributes,
  ItemName,
  Locale,
  WithBlankSearch,
  type WithBlankSearchObject,
  WithExclusion,
  type WithExclusionObject,
} from '@ps-smart-cp/ppfw-client';

interface Schema {
  /**
   * 設置場所マスタコード
   */
  locationMstCode: string;
  /**
   * 設置場所マスタコード(抽出条件)
   */
  locationMstCodeRange: WithExclusionObject;
  /**
   * 設置場所(表示用)
   */
  location: string;
  /**
   * 設置場所コード
   */
  locationCode: string;
  /**
   * 設置場所補足名称
   */
  locationSuppName: string;
  /**
   * 設置場所補足名称(抽出条件)
   */
  locationSuppNameCondition: WithBlankSearchObject;
  /**
   * 設置場所名称
   */
  locationName: string;
  /**
   * 設置場所コード範囲(抽出条件)
   */
  locationCodeRange: WithExclusionObject;
}

interface Record {
  locationMstCode: string;
  locationCode: string;
  locationMstCodeRange: string;
  isLocationMstCodeMstCodeRangeExcluded: boolean;
  location: string;
  locationSuppName: string;
  isLocationSuppNameBlankOnly: boolean;
  locationName: string;
  locationCodeRange: string;
  isLocationCodeRangeExcluded: boolean;
}

const attributes = {
  locationMstCode: Characters.preset.halfWidth({ minLen: 6, maxLen: 6, required: true }),
  locationMstCodeRange: WithExclusion.of(Characters.preset.halfWidth({ maxLen: 250 })),
  location: Characters.preset.halfWidth({ minLen: 6, maxLen: 6 }),
  locationSuppName: Characters.preset.freeFormat({ maxLen: 40 }),
  locationSuppNameCondition: WithBlankSearch.of(Characters.preset.freeFormat()),
  locationName: Characters.preset.freeFormat(),
  locationCodeRange: WithExclusion.of(Characters.preset.halfWidth({ maxLen: 250 })),
} satisfies ItemAttributes<Schema>;

const names = {
  locationMstCode: ItemName.of([Locale.ja, '設置場所']),
  locationMstCodeRange: ItemName.of([Locale.ja, '設置場所範囲']),
  location: ItemName.of([Locale.ja, '設置場所']),
  locationCode: ItemName.of([Locale.ja, '設置場所']),
  locationSuppName: ItemName.of([Locale.ja, '設置場所補足名称']),
  locationSuppNameCondition: ItemName.of([Locale.ja, '設置場所補足名称']),
  locationName: ItemName.of([Locale.ja, '設置場所名称']),
  locationCodeRange: ItemName.of([Locale.ja, '設置場所範囲']),
} satisfies ItemNames<Schema>;

const locationMst = {
  names,
  attributes,
};

interface LocationMst {
  schema: Schema;
  record: Record;
}

export { locationMst };
export type { LocationMst };
